import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { confirmAlert } from "react-confirm-alert";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { deleteJob } from "../../../docuclipper/api";
import { ReduxState } from "../../../redux";
import { createAlert } from "../../../redux/reducers/Alerts";
import { setJobData } from "../../../redux/reducers/JobData";
import { Btn } from "../../../shared/Btn";
import { getCustomUi } from "../../Docuclipper/ConfirmAlert/ConfirmAlert";
import { trackJobDeleted } from "../../../utils/activationFunnelAnalytics";

export function DeleteJobButton({ job }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state: ReduxState) => state.User.user);
  const subscription = useSelector(
    (state: ReduxState) => state.Subscription.subscription,
  );

  const onJobDelete = () => {
    if (!job) {
      return;
    }

    const getMessage = () => (
      <div style={{ marginBottom: "20px" }}>
        <span>{`Are you sure you want to delete this?`}</span>
      </div>
    );

    confirmAlert({
      customUI: getCustomUi({
        onConfirm: () => {
          // Frontend has no reliable "this job has been exported" flag on the
          // Job object — `hadExport` is reported as null so PostHog cohorting
          // can derive it from prior `first_export_clicked` events for the
          // same jobId. The CRO test on pre-export deletes uses that derived
          // join rather than a frontend boolean.
          try {
            const createdAtMs = job?.createdAt
              ? new Date(job.createdAt).getTime()
              : null;
            const jobAgeSeconds =
              createdAtMs && !Number.isNaN(createdAtMs)
                ? Math.floor((Date.now() - createdAtMs) / 1000)
                : null;
            trackJobDeleted({
              jobId: job?.id ?? null,
              userId: (user as any)?.id ?? null,
              jobStatus: job?.status ?? null,
              hadExport: null,
              jobAgeSeconds,
              planName: subscription?.docuclipperPlan?.name ?? null,
            });
          } catch (e) {
            // analytics should never break the UI
          }
          deleteJob(job.id)
            .then((jobRsp) => {
              // IMPORTANT: navigate FIRST so JobDataViewer + its children unmount
              // before we null out state.JobData.job. Otherwise still-mounted
              // children (e.g. EditDocumentInProgress reads job.status in a
              // switch on line 71 with no null guard, SummaryTableAccountViewHorizontal2
              // casts `as Job`) re-render against null and crash with
              // `null.status` — Sentry DOCUCLIPPER-38Y (513 users / 24h).
              history.push("/dataArchive");
              dispatch(setJobData({ job: null as any }));
              dispatch(
                createAlert({
                  message: "Deleted successfully.",
                  timeout: 0,
                  type: "success",
                })
              );
            })
            .catch((err) => {
              dispatch(
                createAlert({
                  message: "Error deleting. Please try again.",
                  timeout: 0,
                  type: "error",
                })
              );
            });
        },
        confirmCTA: "Delete",
        cancelCTA: "Cancel",
        getMessage,
      }),
    });
  };

  return (
    <Btn className="mx-2" variant="danger" onClick={onJobDelete}>
      <FontAwesomeIcon icon="trash" className="mx-2" />
      Delete
    </Btn>
  );
}
